import { createAction, props } from '@ngrx/store';
import {
  FavoriteLocation,
  Itinerary,
  Location,
  OrganizationRiderListItem,
  OrganizationRiderServiceLevel,
  PaymentAccount,
  Provider,
  RideEstimate,
  RideMetadataField,
  RideMetadataValue,
  RideRequest,
  RideRequestInfo,
  RideRequestLocation,
  RideRequestType,
  RideReview,
  RiderNote,
  RideSubscriptionDetail,
  ServiceLevelType,
  TransitProgramInfo,
  TripDetail,
  TripListItem
} from '@uzurv/rideWss/clara';
import { GeoLocationUpdate } from '@uzurv/rideWss/app/models/geo-location-update';
import { AutoCompleteResult } from '@uzurv/rideWss/app/models';
import { LocationTypes } from './rides.reducer';

export const resetStore = createAction('[Rides] reset Store');

export const refreshStaleRideData = createAction('[Rides] refresh stale ride data');

export const rideSelected = createAction('[Rides] ride selected', props<{ rideRequestId: number; setSelectedRide?: boolean }>());

export const clearSelectedRide = createAction('[Rides] clear selected ride');

export const fetchOrganizationRiderListItems = createAction('[Rides] fetch organization rider list items');

export const fetchOrganizationRiderListItemsSuccess = createAction(
  '[Rides] fetch organization rider list items success',
  props<{ organizationRiderListItems: Array<OrganizationRiderListItem> }>()
);

export const fetchOrganizationRiderListItemsFail = createAction(
  '[Rides] fetch organization rider list items fail',
  props<{ error: Error }>()
);

export const fetchUpcomingRideListItems = createAction(
  '[Rides] fetch upcoming ride list items',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const fetchInitialUpcomingRideListItems = createAction(
  '[Rides] fetch initial upcoming ride list items',
  props<{ loggedInUserId: number }>()
);

export const refreshUpcomingRideListItems = createAction('[Rides] refresh upcoming ride list items', props<{ loggedInUserId: number }>());

export const fetchAdditionalUpcomingRideListItems = createAction(
  '[Rides] fetch additional upcoming ride list items',
  props<{ loggedInUserId: number }>()
);

export const fetchUpcomingRideListItemsSuccess = createAction(
  '[Rides] fetch upcoming ride list items success',
  props<{ tripListItems: Array<TripListItem> }>()
);

export const fetchUpcomingRideListItemsSuccessFuture = createAction(
  '[Rides] fetch upcoming ride list items success future',
  props<{ tripListItems: Array<TripListItem> }>()
);

export const refreshUpcomingRideListItemsSuccess = createAction(
  '[Rides] refresh upcoming ride list items success',
  props<{ tripListItems: Array<TripListItem> }>()
);

export const fetchUpcomingRideListItemsFail = createAction('[Rides] fetch upcoming ride list items fail', props<{ error: Error }>());

export const fetchPastRideListItems = createAction(
  '[Rides] fetch past ride list items',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const fetchInitialPastRideListItems = createAction(
  '[Rides] fetch initial past ride list items',
  props<{ loggedInUserId: number }>()
);

export const refreshPastRideListItems = createAction('[Rides] refresh past ride list items', props<{ loggedInUserId: number }>());

export const fetchAdditionalPastRideListItems = createAction(
  '[Rides] fetch additional past ride list items',
  props<{ loggedInUserId: number }>()
);

export const fetchPastRideListItemsSuccess = createAction(
  '[Rides] fetch past ride list items success',
  props<{ tripListItems: Array<TripListItem> }>()
);

export const refreshPastRideListItemsSuccess = createAction(
  '[Rides] refresh past ride list items success',
  props<{ tripListItems: Array<TripListItem> }>()
);

export const fetchPastRideListItemsSuccessFuture = createAction(
  '[Rides] fetch past ride list items success future',
  props<{ tripListItems: Array<TripListItem> }>()
);

export const fetchPastRideListItemsFail = createAction('[Rides] fetch past ride list items fail', props<{ error: Error }>());

export const fetchRideDetail = createAction('[Rides] fetch ride detail', props<{ rideRequestId: number; setSelectedRide?: boolean }>());

export const refreshRideDetail = createAction('[Rides] refresh ride detail', props<{ rideRequestId: number }>());

export const fetchRideDetailSuccess = createAction(
  '[Rides] fetch ride detail success',
  props<{ tripDetail: TripDetail; setSelectedRide?: boolean }>()
);

export const fetchRideDetailFail = createAction('[Rides] fetch ride detail fail', props<{ error: Error }>());

export const fetchRideEstimates = createAction('[Rides] fetch ride estimates', props<{ rideRequestId: number }>());

export const fetchRideEstimatesSuccess = createAction('[Rides] fetch ride estimates success', props<{ rideEstimate: RideEstimate }>());

export const fetchRideEstimatesFail = createAction('[Rides] fetch ride estimates fail', props<{ error: Error }>());

export const activateWillCallRideFromList = createAction('[Rides] activate will call ride from list', props<{ rideRequestId: number }>());

export const activateWillCallRideFromDetail = createAction(
  '[Rides] activate will call ride from detail',
  props<{ rideRequestId: number }>()
);

export const activateWillCallRideSuccess = createAction('[Rides] activate will call ride success', props<{ tripDetail: TripDetail }>());

export const activateWillCallRideFail = createAction(
  '[Rides] activate will call ride fail',
  props<{ rideRequestId: number; error: Error }>()
);

export const fetchClosestTransitProgram = createAction(
  '[Rides] fetch closest transit program',
  props<{ pickUpLocationId: number; dropOffLocationId: number }>()
);

export const fetchClosestTransitProgramSuccess = createAction(
  '[Rides] fetch closest transit program success',
  props<{ transitProgramInfo: TransitProgramInfo }>()
);

export const fetchClosestTransitProgramFail = createAction('[Rides] fetch closest transit program fail', props<{ error: Error }>());

export const fetchRideMetadataFieldsForTransitProgramSuccess = createAction(
  '[Rides] fetch ride meta data fields for transit program success',
  props<{ rideMetadataFields: Array<RideMetadataField> }>()
);

export const fetchRideMetadataFieldsForTransitProgramFail = createAction(
  '[Rides] fetch ride meta data fields for transit program fail',
  props<{ error: Error }>()
);

export const fetchRideRequestInfo = createAction('[Rides] fetch ride request info', props<{ transitProgram: TransitProgramInfo }>());

export const fetchRideRequestInfoSuccess = createAction(
  '[Rides] fetch ride request info success',
  props<{ rideRequestInfo: RideRequestInfo }>()
);

export const fetchRideRequestInfoFail = createAction('[Rides] fetch ride request info fail', props<{ error: Error }>());

export const cancelRide = createAction('[Rides] cancel ride', props<{ rideRequestId: number }>());

export const cancelRideConfirmed = createAction('[Rides] cancel ride confirmed', props<{ tripDetail: TripDetail }>());

export const cancelRideDismissed = createAction('[Rides] cancel ride dismissed');

export const cancelRideSuccess = createAction('[Rides] cancel ride success', props<{ tripDetail: TripDetail }>());

export const cancelRideFail = createAction('[Rides] cancel ride fail', props<{ riderCallCenterPhoneNumber: string; error: Error }>());

export const updateRiderPosition = createAction('[Rides] update rider position', props<{ geoLocationUpdate: GeoLocationUpdate }>());

export const disableSubmit = createAction('[Rides] disable submit', props<{ disableSubmit: boolean }>());

export const startNewItinerary = createAction('[Rides] start new itinerary');

export const startNewItineraryReturnTrip = createAction('[Rides] start new itinerary return trip');

export const startNewItineraryLeg = createAction('[Rides] start new itinerary leg');

export const finishItinerary = createAction('[Rides] finish itinerary');

export const discardItinerary = createAction('[Rides] discard itinerary');

export const selectCurrentLegPickupDate = createAction('[Rides] select current leg pickup date', props<{ date: Date }>());

export const selectCurrentLegPickupTime = createAction('[Rides] select current leg pickup time', props<{ time: string | null}>());

export const selectItineraryDate = createAction('[Rides] select itinerary date', props<{ date: Date }>());

export const selectRideRequestType = createAction('[Rides] select ride request type', props<{ code: string | null }>());

export const selectLocationFromAutocompleteResult = createAction(
  '[Rides] select location from autocomplete result',
  props<{ autoCompleteResult: AutoCompleteResult; locationType: LocationTypes }>()
);

export const geocodeLocationFail = createAction('[Rides] geocode location fail', props<{ error: Error }>());

export const selectLocation = createAction(
  '[Rides] select location',
  props<{ rideRequestLocation: RideRequestLocation; locationType: LocationTypes }>()
);

export const selectServiceLevelType = createAction('[Rides] select service level type', props<{ serviceLevelType: ServiceLevelType }>());

export const setRideBackupAccepted = createAction('[Rides] set ride backup accepted', props<{ isRideBackupAccepted: boolean }>());

export const selectPassengerCount = createAction('[Rides] select passenger count', props<{ passengerCount: number }>());

export const assignRideMetadataValue = createAction('[Rides] assign ride metadataValue', props<{ rideMetadataValue: RideMetadataValue }>());

export const removeRideMetadataValue = createAction('[Rides] remove ride metadataValue', props<{ rideMetadataValue: RideMetadataValue }>());

export const selectRiderHasPca = createAction('[Rides] select rider has pca', props<{ riderHasPca: boolean }>());

export const favoriteLocationSelected = createAction('[Rides] favorite location selected', props<{ favoriteLocation: FavoriteLocation }>());

export const favoriteLocationSearchResultSelected = createAction(
  '[Rides] favorite location search results selected',
  props<{ location: Location }>()
);

export const fetchFavoriteLocations = createAction('[Rides] fetch favorite locations', props<{ personId: number; loading: boolean }>());

export const fetchFavoriteLocationsSuccess = createAction(
  '[Rides] fetch favorite locations success',
  props<{ favoriteLocations: Array<FavoriteLocation> }>()
);

export const fetchFavoriteLocationsFail = createAction('[Rides] fetch favorite locations fail', props<{ error: Error }>());

export const fetchRideRequestTypes = createAction('[Rides] fetch ride request types');

export const fetchRideRequestTypesSuccess = createAction(
  '[Rides] fetch ride request types success',
  props<{ rideRequestTypes: Array<RideRequestType> }>()
);

export const fetchRideRequestTypesFail = createAction('[Rides] fetch ride request types fail', props<{ error: Error }>());

export const fetchOrganizationRiderServiceLevels = createAction('[Rides] fetch organization rider service levels');

export const fetchOrganizationRiderServiceLevelsSuccess = createAction(
  '[Rides] fetch organization rider service levels success',
  props<{ organizationRiderServiceLevels: Array<OrganizationRiderServiceLevel> }>()
);

export const fetchOrganizationRiderServiceLevelsFail = createAction(
  '[Rides] fetch organization rider service levels fail',
  props<{ error: Error }>()
);

export const addOrganizationRiderServiceLevel = createAction(
  '[Rides] add organization rider service level',
  props<{ serviceLevelCode: string }>()
);

export const addOrganizationRiderServiceLevelSuccess = createAction(
  '[Rides] add organization rider service level success',
  props<{ organizationRiderServiceLevel: OrganizationRiderServiceLevel }>()
);

export const addOrganizationRiderServiceLevelFail = createAction(
  '[Rides] add organization rider service level fail',
  props<{ error: Error }>()
);

export const deleteOrganizationRiderServiceLevel = createAction(
  '[Rides] delete organization rider service level',
  props<{ serviceLevelCode: string }>()
);

export const deleteOrganizationRiderServiceLevelSuccess = createAction(
  '[Rides] delete organization rider service level success',
  props<{ success: boolean }>()
);

export const deleteOrganizationRiderServiceLevelFail = createAction(
  '[Rides] delete organization rider service level fail',
  props<{ error: Error }>()
);

export const replaceFavoriteLocation = createAction(
  '[Rides] replace favorite location',
  props<{ toDelete: FavoriteLocation; toCreate: FavoriteLocation }>()
);

export const addFavoriteLocation = createAction('[Rides] add favorite location', props<{ favoriteLocation: FavoriteLocation }>());

export const addFavoriteLocationSuccess = createAction(
  '[Rides] add favorite location success',
  props<{ favoriteLocation: FavoriteLocation }>()
);

export const addFavoriteLocationFail = createAction(
  '[Rides] add favorite location fail',
  props<{ favoriteLocation: FavoriteLocation; error: Error }>()
);

export const addLocation = createAction('[Rides] add location', props<{ display: string; locationType: string }>());

export const addLocationSuccess = createAction(
  '[Rides] add location success',
  props<{ rideRequestLocation: RideRequestLocation; locationType: string }>()
);

export const addLocationFail = createAction('[Rides] add location fail', props<{ error: Error, locationType: string }>());

export const deleteFavoriteLocation = createAction('[Rides] delete favorite location', props<{ favoriteLocation: FavoriteLocation }>());

export const deleteFavoriteLocationSuccess = createAction(
  '[Rides] delete favorite location success',
  props<{ favoriteLocation: FavoriteLocation }>()
);

export const deleteFavoriteLocationFail = createAction(
  '[Rides] delete favorite location fail',
  props<{ favoriteLocation: FavoriteLocation; error: Error }>()
);

export const fetchRecentLocations = createAction('[Rides] fetch recent locations', props<{ loggedInUserId: number }>());

export const fetchRecentLocationsSuccess = createAction('[Rides] fetch recent locations success', props<{ locations: Array<Location> }>());

export const fetchRecentLocationsFail = createAction('[Rides] fetch recent locations fail', props<{ error: Error }>());

export const fetchAutocompleteResults = createAction(
  '[Rides] fetch autocomplete results',
  props<{ autocompleteInputValue: string; locationType: LocationTypes }>()
);

export const fetchAutocompleteResultsSuccess = createAction(
  '[Rides] fetch autocomplete results success',
  props<{ autoCompleteResults: Array<AutoCompleteResult>; locationType: LocationTypes }>()
);

export const fetchAutocompleteResultsFail = createAction('[Rides] fetch autocomplete results fail', props<{ error: Error }>());

export const clearAutocompleteResults = createAction('[Rides] clear autocomplete results');

export const updateCurrentLegDriverNote = createAction('[Rides] update current leg driver note', props<{ driverNote: string }>());

export const updateRideRequestDriverNote = createAction(
  '[Rides] update ride request driver note',
  props<{ riderNote: RiderNote | null }>()
);

export const updateRideRequestDriverNoteSuccess = createAction(
  '[Rides] update ride request driver note success',
  props<{ ride: TripDetail }>()
);

export const updateRideRequestDriverNoteFail = createAction('[Rides] update ride request driver note fail', props<{ error: Error }>());

export const removeRideRequestDriverNote = createAction('[Rides] remove ride request driver note', props<{ ride: TripDetail }>());

export const removeRideRequestDriverNoteSuccess = createAction(
  '[Rides] remove ride request driver note success',
  props<{ ride: TripDetail }>()
);

export const removeRideRequestDriverNoteFail = createAction('[Rides] remove ride request driver note fail', props<{ error: Error }>());

export const setPaymentCollectionDetailsForNewItinerary = createAction(
  '[Rides] set payment collection details for new itinerary',
  props<{ paymentCollectionTypeCode: string; paymentAccount: PaymentAccount }>()
);

export const setPaymentCollectionDetailsForNewItinerarySuccess = createAction(
  '[Rides] set payment collection details for new itinerary success',
  props<{ paymentCollectionTypeCode: string; paymentAccount: PaymentAccount }>()
);

export const setPaymentCollectionDetailsForNewItineraryFail = createAction(
  '[Rides] set payment collection details for new itinerary fail',
  props<{ error: Error }>()
);

export const submitItinerary = createAction('[Rides] submit itinerary');

export const submitItinerarySuccess = createAction('[Rides] submit itinerary success', props<{ itinerary: Itinerary }>());

export const submitItineraryFail = createAction('[Rides] submit itinerary fail', props<{ error: Error }>());

export const addRideRequestToItinerarySuccess = createAction(
  '[Rides] add ride request to itinerary success',
  props<{ rideRequest: RideRequest }>()
);

export const addRideRequestToItineraryFail = createAction('[Rides] add ride request to itinerary fail', props<{ error: Error }>());

export const fetchAvailableProviders = createAction('[Rides] fetch available providers');

export const fetchAvailableProvidersSuccess = createAction(
  '[Rides] fetch available providers success',
  props<{ availableProviders: Array<Provider> }>()
);

export const fetchAvailableProvidersFail = createAction('[Rides] fetch available providers fail', props<{ error: Error }>());

export const selectPreferredProvider = createAction('[Rides] select preferred provider', props<{ preferredProviderId: number }>());

export const startNewRideSubscription = createAction(
  '[Rides] start new ride subscription',
  props<{ days: Array<string>; startDate: Date; endDate: Date }>()
);

export const updateRideSubscriptionDetails = createAction(
  '[Rides] update ride subscription details',
  props<{ days: Array<string>; startDate: Date; endDate: Date }>()
);

export const updateRideSubscriptionDetailsSuccess = createAction(
  '[Rides] update ride subscription details success',
  props<{ itinerary: Itinerary }>()
);

export const updateRideSubscriptionDetailsFail = createAction('[Rides] update ride subscription details fail', props<{ error: Error }>());

export const processRideSubscriptionItineraryForSubmission = createAction(
  '[Rides] process ride subscription itinerary for submission',
  props<{ riderId: number }>()
);

export const createRideSubscription = createAction('[Rides] create ride subscription');

export const createRideSubscriptionSuccess = createAction(
  '[Rides] create ride subscription success',
  props<{ rideSubscriptionDetail: RideSubscriptionDetail }>()
);

export const createRideSubscriptionFail = createAction('[Rides] create ride subscription fail', props<{ error: Error }>());

export const deleteSubscriptionLeg = createAction('[Rides] delete subscription leg', props<{ index: number }>());

export const editSubscriptionLeg = createAction('[Rides] edit subscription leg', props<{ index: number }>());

export const setIsEditingSubscriptionDetails = createAction(
  '[Rides] set is editing subscription details',
  props<{ isEditingSubscriptionDetails: boolean }>()
);

export const fetchMatchingUnclaimedOrganizationRiders = createAction('[Rides] fetch matching unclaimed organization riders');

export const fetchMatchingUnclaimedOrganizationRidersSuccess = createAction(
  '[Rides] fetch matching unclaimed organization riders success',
  props<{ matchingUnclaimedOrganizationRiderListItems: Array<OrganizationRiderListItem> }>()
);

export const fetchMatchingUnclaimedOrganizationRidersFail = createAction(
  '[Rides] fetch matching unclaimed organization riders fail',
  props<{ error: Error }>()
);

export const claimOrganizationRider = createAction(
  '[Rides] claim organization rider',
  props<{ loggedInUserId: number; organizationRider: OrganizationRiderListItem; customerId: string }>()
);

export const claimOrganizationRiderSuccess = createAction(
  '[Rides] claim organization rider success',
  props<{ organizationRiderListItem: OrganizationRiderListItem }>()
);

export const claimOrganizationRiderFail = createAction('[Rides] claim organization rider fail', props<{ error: Error }>());

export const ignoreOrganizationRider = createAction(
  '[Rides] ignore organization rider',
  props<{ loggedInUserId: number; organizationRiderId: number }>()
);

export const ignoreOrganizationRiderSuccess = createAction(
  '[Rides] ignore organization rider success',
  props<{ organizationRiderId: number }>()
);

export const ignoreOrganizationRiderFail = createAction('[Rides] ignore organization rider fail', props<{ error: Error }>());

export const selectOrganizationRiderListItem = createAction(
  '[Rides] select organization rider list item',
  props<{ selectedOrganizationRiderListItem: OrganizationRiderListItem }>()
);

export const acceptRideBackup = createAction('[Rides] accept ride backup', props<{ ride: TripDetail }>());

export const acceptRideBackupSuccess = createAction('[Rides] accept ride backup success', props<{ ride: TripDetail }>());

export const acceptRideBackupFail = createAction('[Rides] accept ride backup fail', props<{ error: Error }>());

export const delayPickupTime = createAction('[Rides] delay pickup time', props<{ ride: TripDetail; pickUpDate: Date }>());

export const delayPickupTimeSuccess = createAction('[Rides] delay pickup time success', props<{ ride: TripDetail }>());

export const delayPickupTimeFail = createAction('[Rides] delay pickup time fail', props<{ error: Error }>());

export const submitRideReview = createAction('[Rides] submit ride review', props<{ reservationId: number; driverRating: RideReview }>());

export const submitRideReviewSuccess = createAction('[Rides] submit ride review success', props<{ rideReview: RideReview }>());

export const submitRideReviewFail = createAction('[Rides] submit ride review fail', props<{ error: Error }>());
